import { creatUUId } from '../../redux/helper/CreateUUID';

export const awsRegion = import.meta.env.REACT_APP_AWS_REGION;
export const s3Bucket = import.meta.env.REACT_APP_S3_BUCKET;
export const accessKeyId = import.meta.env.REACT_APP_ACCESS_KEY_ID;
export const secreteAccessKey = import.meta.env.REACT_APP_SECRETE_ACCESS_KEY;
export const appStage = import.meta.env.REACT_APP_STAGE;
export const Uploadconfig = {
    bucketName: s3Bucket,
    region: awsRegion,
    accessKeyId,
    dirName: `eub/${creatUUId()}`,
    secretAccessKey: secreteAccessKey,
};
